import { ValidationError } from "sequelize"
import {
    RrsTemplateLevel,
    RrsTemplateLevelCreate,
    RrsTemplateLevelSave,
} from "server/models"
import { GET, POST, DELETE, validate } from "client/store/utils"
import {
    LangType,
    RrsTemplateLevelByCategoryList,
    RrsTemplateLevelValidation,
} from "client/store"

export const LoadAllRrsTemplateLevels = (labelId: number) => (
    GET(`/rrsTemplateLevel/labelId/${labelId}`)
    .then((levels: RrsTemplateLevel[]) => {
        const levelList: RrsTemplateLevelByCategoryList = {}
        levels.forEach((level) => {
            const categoryId = level.categoryId || 0
            if (!levelList[categoryId]) {
                levelList[categoryId] = {
                    levelIds: [],
                    levelList: {},
                }
            }
            levelList[categoryId].levelIds.push(level.id)
            levelList[categoryId].levelList[level.id] = level
        })
        return levelList
    })
)

export const LoadRrsTemplateLevelById = (levelId: number) => (
    GET(`/rrsTemplateLevel/id/${levelId}`)
    .then((level: RrsTemplateLevel) => level)
)

export const SaveRrsTemplateLevel = (
    id: number,
    level: RrsTemplateLevelCreate,
    lang: LangType,
) => {
    const data: RrsTemplateLevelSave = {
        id,
        level,
    }
    return POST(
        "/rrsTemplateLevel/save",
        JSON.stringify(data),
    ).then((res) => {
        const newLevel = res as RrsTemplateLevel
        const error = res as ValidationError

        return {
            newLevelId: newLevel.id || null,
            validation: <RrsTemplateLevelValidation>validate(error, lang),
        }
    })
}

export const DeleteRrsTemplateLevelsForLabel = (labelId: number) => ( // when change label category
    DELETE(`/rrsTemplateLevel/deleteForLabel/${labelId}`)
    .then((removedRows: number) => removedRows)
)

export const DeleteRrsTemplateLevel = (levelId: number) => (
    DELETE(`/rrsTemplateLevel/delete/${levelId}`)
    .then((removedRows: number) => removedRows)
)
